<template>
    <cp-select
        :config="routeData"
        item-value="id"
        item-text="trade_name"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :persistent="true"
    />
</template>

<script>

export default {
    data: () => ({
        routeData: {route: 'v2.core.resellers'},
    }),
    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione um Canal',
                name: name || "select-reseller"
            }, ...attrs };
        }
    }
}
</script>